import axios from "./configAxios";

export const getOneUser = async(userId) => {
    return await axios.get(`/${userId}/`)
}